export function getMonthYear(date) {
  if (!date) return;
  return new Intl.DateTimeFormat("en-US", { year: "numeric", month: "short" }).format(new Date(date));
}
